/**
 * Created by hanyong.zheng on 2018/12/26.
 */
import request from '@/utils/request'
export function addService (object) {
  const data = object
  return request({
    url: '/saveAddedService',
    method: 'post',
    data
  })
}

export function getServiceList (userId) {
  const data = {
    'userId': userId
  }
  return request({
    url: '/getAddedServiceList',
    method: 'post',
    data
  })
}

export function getServiceInfo (repairParams) {
  const data = {
    'serviceId': repairParams.id,
    'serviceType': repairParams.serviceType,
    'userId': repairParams.userId
  }
  return request({
    url: '/getAddedServiceInfo',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/service.js